import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { adminProductos, getProductos } from "../../Services/producto_service";

const initialState = {
    productos: [],
    producto: {
        nombre: '',
        estado: 1,
    },
}

export const productoSlice = createSlice({
    name: 'producto',
    initialState,
    reducers: {
        setProductos: (state, action) => {
            state.productos = action.payload;
        },
        setProducto: (state, action) => {
            state.producto = action.payload ?? initialState.producto;
        },
    }
});

export const fetchProductos = createAsyncThunk(
    'producto/fetchSegmentosProductos',
    async (_, { dispatch }) => {
        const productosRes = await getProductos();
        dispatch(setProductos(productosRes));
    }
);

export const mergeProducto = createAsyncThunk(
    'producto/merge',
    async (data, {dispatch}) => {
        dispatch(setLoading(true))
        const productoRes = await adminProductos(data);
        dispatch(setResponse(productoRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchProductos());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setProductos, setProducto } = productoSlice.actions;
export default productoSlice.reducer;